import { IterationsManager } from "./S3_Iterations_Manager";

/**
 * 🛰️ S3 UTILITY CONTROLLER
 * Decouples the button logic from the React View.
 */
export const S3UtilityController = {
    /**
     * Executes the requested S3 Utility function across selected items.
     */
    execute: async (action, selectedPaths, context) => {
        const { targetBucket, config, setWorkerStatus, refreshS3Inventory, setSelectedPaths } = context;

        if (selectedPaths.length === 0) return;

        // 1. SELECT (Local Session Injection)
        if (action === "SELECT") {
            IterationsManager.selectToSessionContext(selectedPaths);
            alert(`Injected ${selectedPaths.length} objects into Session Context.`);
            return;
        }

        // 2. Safety Confirmation
        const displayLabel = action === "BulkClean" ? "CLEAN (Archive)" : action.toUpperCase();
        if (action !== "Rename" && !window.confirm(`S3 UTILITY: Execute ${displayLabel} on ${selectedPaths.length} items?`)) {
            return;
        }

        // 3. Iterative Execution (The Worker/Halo)
        setWorkerStatus({ active: true, current: 0, total: selectedPaths.length, label: `Utility: ${action}...` });

        try {
            if (action === "Rename") {
                await IterationsManager.renameIteration(targetBucket, config, selectedPaths, (curr, tot, path) => {
                    setWorkerStatus({ active: true, current: curr, total: tot, label: `Renaming: ${path}` });
                });
            } else if (action === "BulkClean") {
                await IterationsManager.runIterationWorker(targetBucket, config, selectedPaths, "BulkClean", (curr, tot, path) => {
                    setWorkerStatus({ active: true, current: curr, total: tot, label: `Archiving: ${path}` });
                });
            } else if (action === "Remove") {
                await IterationsManager.runIterationWorker(targetBucket, config, selectedPaths, "Remove", (curr, tot, path) => {
                    setWorkerStatus({ active: true, current: curr, total: tot, label: `Removing: ${path}` });
                });
            }
            
            await refreshS3Inventory();
            setSelectedPaths([]);
        } catch (err) {
            console.error(`S3 Utility Failure [${action}]:`, err);
        } finally {
            setWorkerStatus({ active: false, current: 0, total: 0, label: "" });
        }
    }
};